export function validateTemplate(template, validTokens) {
  let usedTokens = template.match(/{{[^}]+}}/g) || [];
  const inValidTokens = [];
  let valid = true;

  usedTokens.forEach((usedToken) => {
    if (!validTokens.includes(usedToken)) {
      inValidTokens.push(usedToken);
    }
  });

  const thereAreInvalidTokens = inValidTokens.length !== 0;

  if (thereAreInvalidTokens) {
    valid = false;
  }

  return {
    isValid: valid,
    inValidTokens: inValidTokens,
  };
}
